import { isAuthenticationComplete } from './authenticationBy';

type ProjectCreationProfile = {
  authentication_by?: string;
  authentication_image_url?: string;
  registration_card_url?: string;
  mission_field?: string;
  birth_date?: string;
  country_code?: string;
  language_type?: string;
  bank_location_country_code?: string;
  bank_name?: string;
  bank_account?: string;
  bank_account_holder?: string;
  bankbook_image_url?: string;
  address1?: string;
  city?: string;
  state_province?: string;
  zipcode?: string;
} | null | undefined;

const hasText = (value: unknown) => Boolean(String(value ?? '').trim());

export const canCreateNewProject = (profile: ProjectCreationProfile): boolean => {
  if (!profile) return false;

  const isComplete = isAuthenticationComplete(profile.authentication_by);
  const hasAuthImage = hasText(profile.authentication_image_url);
  const hasRegistrationCard = hasText(profile.registration_card_url);
  const isInProgress = hasAuthImage || hasRegistrationCard;
  const hasRequiredBasicFields =
    hasText(profile.birth_date) &&
    hasText(profile.country_code) &&
    hasText(profile.language_type) &&
    hasText(profile.mission_field);

  const bankCountry = String(profile.bank_location_country_code ?? 'KR').trim().toUpperCase();
  const hasBankFields =
    bankCountry === 'US'
      ? hasText(profile.address1) && hasText(profile.city) && hasText(profile.state_province) && hasText(profile.zipcode)
      : hasText(profile.bank_name) &&
        hasText(profile.bank_account) &&
        hasText(profile.bank_account_holder) &&
        hasText(profile.bankbook_image_url);

  return isComplete || isInProgress || (hasRequiredBasicFields && hasBankFields);
};

